import {
  AutoComplete,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Layout,
  Row,
  Select,
  Spin,
  Tabs,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import InputField from "../../common/htmlComponents/InputField";
import { ReactComponent as AddressLine } from "../../image/AddressLine.svg";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import verifybtn from "../../image/verifybtn.png";
import { Content } from "antd/lib/layout/layout";

import ShippingSiteLocationKeyPerson from "./../../feature/deliveryAddress/ShippingSiteLocationKeyPerson";
import StepSider from "./StepSider";
import BillingSiteLocationKeyPerson from "./../../feature/deliveryAddress/BillingSiteLocationKeyPerson";
import TabPane from "antd/lib/tabs/TabPane";
import SiteWiseMaterialCompany from "../../feature/companyMaterialMaster/SIteWiseMaterialCompany";
import { InfoCircleOutlined } from "@ant-design/icons";

const AddSiteLocationStep = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Option } = Select;
  // const { Panel } = Collapse;
  // const { Option } = AutoComplete;
  const { id } = useParams();
  const AddressId = id ? id : null;
  const formRef = useRef();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const initialState = {
    company: authUserData()?.company,
    company_legal_name: "",
    // site_short_name: "",
    site_name: "",
    gst_number: "",
    wbs_choice: "Common Wise For Site",
    common_wbs_number: "",
    billing_state: "",
    billing_city: "",
    billing_address_line_1: "",
    billing_address_line_2: "",
    billing_landmark: "",
    billing_pincode: "",
    billing_email: "",
    billing_phone: "",
    gst_no_verified: false,
    billing_alternative_phone_number: "",
    billing_contact_person_name: "",
    shipping_state: "",
    shipping_city: "",
    shipping_address_line_1: "",
    shipping_address_line_2: "",
    shipping_landmark: "",
    shipping_pincode: "",
    shipping_email: "",
    shipping_phone: "",
    sameAsCurrentAddress: false,
    shipping_alternative_phone_number: "",
    shipping_contact_person_name: "",
    wbs_numbers: [
      {
        wbs_number: null,
        category: 1,
      },
    ],
    delivery_address_billing_keypersons: [
      {
        persons_name: null,
        mobile_number: null,
        email: null,
      },
    ],
    delivery_address_shipping_keypersons: [
      {
        persons_name: null,
        mobile_number: null,
        email: null,
      },
    ],
  };

  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [pincodeListBilling, setPincodeListBilling] = useState([]);
  // const [searchValueBilling, setSearchValueBilling] = useState("");
  const [pincodeListShipping, setPincodeListShipping] = useState([]);
  // const [searchValueShipping, setSearchValueShipping] = useState("");
  const [selectedOption, setSelectedOption] = useState("Common Wise For Site");
  // const [categoryTree, setCategoryTree] = useState([]);
  const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  // const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  // const [stateDropdownOptions, setStateDropdownOptions] = useState([]);
  // const [cityDropdownOptions, setCityDropdownOptions] = useState([]);
  // const [cityDropdownOptionsShipping, setCityShipping] = useState([]);
  // const [stateDropdownOptionsShipping, setShippingState] = useState([]);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [btnLoadingVerifyGst, setBtnLoadingVerifyGst] = useState(false);
  const [verifyGstDisable, setVerifyDisable] = useState(true);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [activeKey, setActiveKey] = useState("1");

  const handleTabChange = async (key) => {
    // console.log("keyxz", key, typeof key);
    // handleSubmit();
    setActiveKey(key);

    // const isSuccess = await handleSubmit();
    // if (isSuccess) {
    //   setActiveKey(key);
    // }
  };

  useEffect(() => {
    const addressGetById = async () => {
      try {
        setapiLoading(true);
        const apiResponse = await getRequest(`delivery-address/${AddressId}/`);
        // console.log(AddressId, "addid");
        // console.log(apiResponse, "res");
        if (apiResponse.data.success) {
          console.log(apiResponse.data.success, "success");
          const {
            id,
            wbs_number,

            ...filteredResponse
          } = apiResponse.data.data;

          // const updatedData = excludeIdFields(apiResponse.data.data);
          // setState(updatedData);
          // Extract data for setting fields value
          // const { delivery_address, ...restData } = updatedData;
          // const { company_legal_name, site_name, gst_number } = restData;
          setState({
            // ...apiResponse.data.data,
            ...filteredResponse,
            // wbs_numbers: apiResponse.data.data.wbs_number.map((wbs) => {
            //   const { id, addressmaster, ...rest } = wbs;
            //   return rest;
            // }),

            delivery_address_billing_keypersons:
              apiResponse.data.data.delivery_address_billing_keypersons.map(
                (e) => ({
                  persons_name: e.persons_name,
                  id: e.id,
                  address_master: e.address_master,
                  email: e.email,
                  mobile_number: e.mobile_number,
                })
              ),
          });
          const delivery_address_billing_keypersons =
            apiResponse.data.data.delivery_address_billing_keypersons.map(
              (e) => ({
                persons_name: e.persons_name,
                email: e.email,
                mobile_number: e.mobile_number,
              })
            );

          // console.log(delivery_address_billing_keypersons);

          //setWeightSizeFieldValue(apiResponse.data.data.delivery_address_billing_keypersons);
          // const modifiedInquiry = apiResponse.data.data.delivery_address_billing_keypersons.map((inquiryDetail) => {
          //   const { id, company, company_name, ...rest } = inquiryDetail;
          //   return rest;
          // });
          setWeightSizeFieldValue(
            apiResponse.data.data.delivery_address_billing_keypersons
          );
          // setWeightSizeFieldValue(modifiedInquiry);
          // console.log("ddscdsapiResponse");

          //getCityByState(apiResponse.data.data.billing_state);
          //getCityByStateForShipping(apiResponse.data.data.shipping_state);
          const url = apiResponse.data.data.company_address_master_logo;

          setIdentifyProfileUrl(
            apiResponse.data.data.company_address_master_logo
          );
          if (url !== null) {
            setFileList([
              {
                // uid: '-1',
                // name: 'image.png',
                // status: 'done',
                url: url,
              },
            ]);
          }
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,

            company_legal_name: apiResponse.data.data.company_legal_name,
            shipping_pincode: apiResponse.data.data.shipping_pincode_number,
            shipping_phone: String(apiResponse.data.data.shipping_phone),
            shipping_alternative_phone_number: String(
              apiResponse.data.data.shipping_alternative_phone_number
            ),
            billing_pincode: apiResponse.data.data.billing_pincode_number,
            billing_phone: String(apiResponse.data.data.billing_phone),
            billing_alternative_phone_number: String(
              apiResponse.data.data.billing_alternative_phone_number
            ),
            // wbs_choice: apiResponse.data.data.wbs_choice,
          });
          // setSelectedOption(apiResponse.data.data.wbs_choice);
          // const modifiedWbsNumbers = apiResponse.data.data.wbs_number.map(
          //   (wbsNumbers) => {
          //     const { id, addressmaster, ...rest } = wbsNumbers;
          //     return rest;
          //   }
          // );
          // setWeightSizeFieldValue(modifiedWbsNumbers);

          // setState(apiResponse.data.data);
          // formRef.current.setFieldsValue({
          //   ...apiResponse.data.data,
          //   phone: String(apiResponse.data.data.phone),
          // });
          const response = apiResponse.data.data;
          // setapiLoading(false);
          if (
            response?.billing_state === response?.shipping_state &&
            response?.billing_city === response?.shipping_city &&
            response?.billing_address_line_1 ===
              response?.shipping_address_line_1 &&
            response?.billing_address_line_2 ===
              response?.shipping_address_line_2 &&
            response?.billing_landmark === response?.shipping_landmark &&
            response?.billing_pincode === response?.shipping_pincode &&
            response?.billing_email === response?.shipping_email &&
            response?.billing_phone === response?.shipping_phone &&
            response?.billing_alternative_phone_number ===
              response?.shipping_alternative_phone_number &&
            response?.shipping_contact_person_name ===
              response?.billing_contact_person_name
          ) {
            setSameAsCurrentAddress(true);
          }
        } else {
          ErrorNotificationMsg(t("error_in_list_delivery_address"));
          sameAsCurrentAddress(false);
        }
        setapiLoading(false);

        // setSameAsCurrentAddress(apiResponse.data.data.sameAsCurrentAddress);
      } catch (error) {
        setapiLoading(false);
      }
    };

    // const excludeIdFields = (data) => {
    //   if (data && typeof data === "object") {
    //     // Exclude id from the outer object
    //     const { id, ...rest } = data;

    //     // Exclude id from each object inside the delivery_address array
    //     const updatedDeliveryAddress = rest.delivery_address.map((address) => {
    //       const { id: addressId, ...restAddress } = address;
    //       return restAddress;
    //     });

    //     // Return the updated data
    //     return {
    //       ...rest,
    //       delivery_address: updatedDeliveryAddress,
    //     };
    //   }
    //   return data;
    // };
    if (AddressId !== null) {
      addressGetById();
    }
  }, [AddressId, t, activeKey]);

  useEffect(() => {
    // getPincode();
    getCategoryTree();
    // getCityByState();
    // getState();
    // getStateShipping();
  }, []);

  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);
    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };

  // const getPincode = async (data) => {
  //   await getRequest("pincode/", data).then((response) => {
  //     setPincodeName(response.data.results.data);
  //   });
  // };
  //Pincode Billing

  // const getCityByState = async () => {
  //   await getRequest("state/?no_pagination=true").then(
  //     (response) => {
  //       setStateDropdownOptions(response.data.data);
  //     }
  //   );
  // };
  // const getCityByState = async (StateId) => {
  //   await getRequest(`city/${StateId}/`).then((response) => {
  //     {
  //       console.log(response, "RESPONSEEEEEE");
  //     }
  //     setCityDropdownOptions(response.data.data);
  //   });
  // };
  // const getState = async () => {
  //   await getRequest("state/?no_pagination=true").then((response) => {
  //     {
  //       console.log(response, "RESPONSEEEEEE");
  //     }
  //     setStateDropdownOptions(response.data.data);
  //   });
  // };
  // const getCityByStateForShipping = async (StateId) => {
  //   await getRequest(`city/${StateId}/`).then((response) => {
  //     {
  //       console.log(response, "RESPONSEEEEEE");
  //     }
  //     setCityShipping(response.data.data);
  //   });
  // };
  // const getStateShipping = async () => {
  //   await getRequest("state/?no_pagination=true").then((response) => {
  //     {
  //       console.log(response, "RESPONSEEEEEE");
  //     }
  //     setShippingState(response.data.data);
  //   });
  // };
  // const handleCityChange = (values) => {
  //   // const updatedAssignSite = [...state.assgin_site]; // Copying the array to avoid mutating state directly
  //   // updatedAssignSite[0] = { ...updatedAssignSite[0], material_type: values }; // Updating the category_tree field
  //   setState({ ...state, billing_city: values }); // Updating the state with the new category_tree value
  // };

  // const handleCityChangeShipping = (values) => {
  //   // const updatedAssignSite = [...state.assgin_site]; // Copying the array to avoid mutating state directly
  //   // updatedAssignSite[0] = { ...updatedAssignSite[0], material_type: values }; // Updating the category_tree field
  //   setState({ ...state, shipping_city: values }); // Updating the state with the new category_tree value
  // };

  // const handleStateChange = (values) => {
  //   console.log(values, "Valuessss");
  //   // const updatedAssignSite = [...state.assgin_site]; // Copying the array to avoid mutating state directly
  //   // updatedAssignSite[0] = {
  //   //   ...updatedAssignSite[0],
  //   //   category_tree: values,
  //   //   material_type: null,
  //   // }; // Updating the category_tree field
  //   setState({ ...state, billing_state: values, billing_city: null }); // Updating the state with the new category_tree value
  //   // setCityDropdownOptions([]);
  //   formRef.current.setFieldsValue({
  //     ...state,
  //     billing_state: values,
  //     billing_city: "",
  //   });
  //   // Fetch material types based on the selected category
  //   // if (values !== null && values !== undefined) {
  //   //   getCityByState(values); //1 0
  //   // }
  // };
  // const handleStateChangeShipping = (values) => {
  //   console.log(values, "Valuessss");
  //   setState({ ...state, shipping_state: values, shipping_city: null }); // Updating the state with the new category_tree value
  //   // setCityShipping([]);
  //   formRef.current.setFieldsValue({
  //     ...state,
  //     shipping_state: values,
  //     shipping_city: "",
  //   });
  //   // Fetch material types based on the selected category
  //   // if (values !== null && values !== undefined) {
  //   //   getCityByStateForShipping(values); //1 0
  //   // }
  // };

  // const handlePincodeBillingChange = (name, value) => {
  //   // Assuming you have a state variable called 'pincode'
  //   // setPincode(!value ? "" : value); // Set 'pincode' state to pincode_number

  //   // If you have another state variable called 'selectedPincodeId', set it to the corresponding 'id'
  //   const selectedOption = pincodeListBilling.find(
  //     (option) => option.pincode_number === value
  //   );
  //   const selectedBillingPincode = selectedOption?.pincode_number;

  //   const selectedId = selectedOption ? selectedOption.id : null;
  //   // setSelectedPincodeId(selectedId);
  //   setState({
  //     ...state,
  //     [name]: selectedId,
  //     billing_pincode_number: selectedBillingPincode,
  //   });
  // };
  const handlePincodeBillingChange = async (billing_pincode) => {
    console.log(billing_pincode, "Billing Pincode");
    if (
      billing_pincode !== null &&
      billing_pincode !== undefined &&
      billing_pincode !== "" &&
      billing_pincode.length > 4
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${billing_pincode}`
        );
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            billing_state: state_name,
            billing_city: city_name,
            billing_pincode: id,
            billing_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            billing_state: state_name,
            billing_city: city_name,
          });
        }
        // setApiLoading(false);
      } catch (error) {
        // setApiLoading(false);
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        billing_state: "",
        billing_city: "",
        billing_pincode: null,
        billing_pincode_number: "",
      }));
      formRef.current.setFieldsValue({ billing_state: "", billing_city: "" });
    }
  };

  const searchINBilling = async (value) => {
    // http://127.0.0.1:8000/pincode/?search_pincode_number=38001
    // console.log(value, "mewwhyhew");

    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    //     setPincodeList(apiResponse.data.results.data);
    //   });
    // const apiResponse = await getRequest(
    //   `facility/list-facility-search/?search_on=${searchOn}&search_text=${value}`
    // );
    if (apiResponse.data.results.success) {
      // setPincodeList(
      //   apiResponse.data.results.data.map(function (el) {
      //     return el.pincode_number;
      //   })
      // );
      setPincodeListBilling(apiResponse.data.results.data);
      // setSuggestions(
      //   apiResponse.data.data.map(function (el) {
      //     return el.formulation_type;
      //   })
      // );
    }
  };
  // const onSelectBilling = (data) => {
  //   // setSearch(!data ? "" : data);
  //   // setSearchValueBilling(!data ? "" : data);
  //   // const selectedOption = pincodeList.find(
  //   //   (option) => option.pincode_number === data
  //   // );
  //   // const selectedId = selectedOption ? selectedOption.id : null;
  //   // // setSelectedPincodeId(selectedId);
  //   // setState({ ...state, pincode: selectedId });
  // };
  const onSearchBilling = async (value) => {
    // setSearch(!value ? "" : value);
    // console.log(value, "valueeee");
    // setSearchValueBilling(value);
    // value.length === 0 ? setSearch(value) : setPincodeList([]);
    value.length >= 4
      ? searchINBilling(!value ? null : value)
      : setPincodeListBilling([]);
    // if (value.length >= 2) {
    //   searchIN(!value ? null : value);
    //   // setSearch(!value ? "" : value);
    //   // searchBusinessLounge(value);
    // } else {
    //   setPincodeList([]);
    // }
  };

  //Pincode Shipping

  //  const handlePincodeShippingChange = (name, value) => {
  //   // Assuming you have a state variable called 'pincode'
  //   // setPincode(!value ? "" : value); // Set 'pincode' state to pincode_number

  //   // If you have another state variable called 'selectedPincodeId', set it to the corresponding 'id'
  //   const selectedOption = pincodeListShipping.find(
  //     (option) => option.pincode_number === value
  //   );
  //   const selectedId = selectedOption ? selectedOption.id : null;
  //   // setSelectedPincodeId(selectedId);
  //   setState({ ...state, [name]: selectedId });
  // };
  const handlePincodeShippingChange = async (shipping_pincode) => {
    if (
      shipping_pincode !== null &&
      shipping_pincode !== undefined &&
      shipping_pincode !== "" &&
      shipping_pincode.length > 4
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${shipping_pincode}`
        );
        console.log(response, "responsed");
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id } = response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            shipping_state: state_name,
            shipping_city: city_name,
            shipping_pincode: id,
          }));
          formRef.current.setFieldsValue({
            shipping_state: state_name,
            shipping_city: city_name,
          });
        }
        // setApiLoading(false);
      } catch (error) {
        // setApiLoading(false);
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        shipping_state: "",
        shipping_city: "",
        shipping_pincode: null,
      }));
      formRef.current.setFieldsValue({ shipping_state: "", shipping_city: "" });
    }
  };
  const searchINShipping = async (value) => {
    // http://127.0.0.1:8000/pincode/?search_pincode_number=38001
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    //     setPincodeList(apiResponse.data.results.data);
    //   });
    // const apiResponse = await getRequest(
    //   `facility/list-facility-search/?search_on=${searchOn}&search_text=${value}`
    // );
    if (apiResponse.data.results.success) {
      // setPincodeList(
      //   apiResponse.data.results.data.map(function (el) {
      //     return el.pincode_number;
      //   })
      // );
      setPincodeListShipping(apiResponse.data.results.data);
      // setSuggestions(
      //   apiResponse.data.data.map(function (el) {
      //     return el.formulation_type;
      //   })
      // );
    }
  };
  // const onSelectShipping = (data) => {
  //   // setSearch(!data ? "" : data);
  //   // setSearchValueShipping(!data ? "" : data);
  //   // const selectedOption = pincodeList.find(
  //   //   (option) => option.pincode_number === data
  //   // );
  //   // const selectedId = selectedOption ? selectedOption.id : null;
  //   // // setSelectedPincodeId(selectedId);
  //   // setState({ ...state, pincode: selectedId });
  // };
  const onSearchShipping = async (value) => {
    // setSearch(!value ? "" : value);
    // setSearchValueShipping(value);
    // value.length === 0 ? setSearch(value) : setPincodeList([]);
    value.length >= 4
      ? searchINShipping(!value ? null : value)
      : setPincodeListShipping([]);
    // if (value.length >= 2) {
    //   searchIN(!value ? null : value);
    //   // setSearch(!value ? "" : value);
    //   // searchBusinessLounge(value);
    // } else {
    //   setPincodeList([]);
    // }
  };

  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        // setCategoryTree(response.data.data);
      }
    );
  };

  // const handleOptionChange = (name, value) => {
  //   if (value === "Category Wise WBS") {
  //     setState({
  //       ...state,
  //       [name]: value,
  //       common_wbs_number: null,
  //       wbs_numbers: [
  //         {
  //           category: 1,
  //           wbs_number: null,
  //         },
  //       ],
  //     });

  //     setSelectedOption("Category Wise WBS");
  //     formRef.current.setFieldsValue({
  //       common_wbs_number: "",
  //     });
  //   } else {
  //     // setState({ ...state, [name]: value });
  //     const newState = {
  //       ...state,
  //       [name]: value,
  //       // unique_code: null,
  //     };
  //     setSelectedOption(value);
  //     setState((prevState) => ({
  //       ...prevState,
  //       ...newState,
  //       // wbs_numbers: state.wbs_numbers.map((person) => ({
  //       //   category: null,
  //       //   wbs_number: null,
  //       // })),
  //       wbs_numbers: [
  //         {
  //           category: 1,
  //           wbs_number: null,
  //         },
  //       ],
  //     }));
  //     state.wbs_numbers.forEach((person, index) => {
  //       formRef.current.setFieldsValue({
  //         [`category${index}`]: "Cement",
  //         [`wbs_number${index}`]: null,
  //       });
  //     });
  //     setWeightSizeFieldValue([]);
  //   }
  // };
  // const handleSelectChange = (name, value) => {
  //   setState({ ...state, [name]: value });
  // };

  // const phoneValidLength = state.phone3;

  // const validatePhoneNumber = () => {
  //   if (
  //     (phoneValidLength && phoneValidLength.length < 12) ||
  //     phoneValidLength === null ||
  //     phoneValidLength === ""
  //   ) {
  //     return Promise.reject(new Error("Please enter valid phone."));
  //   }
  //   return Promise.resolve();
  // };

  // const phoneValidLengthNumber = state.phone4;

  // const validatePhone_Number = () => {
  //   if (
  //     (phoneValidLengthNumber && phoneValidLengthNumber.length < 8) ||
  //     phoneValidLengthNumber === null ||
  //     phoneValidLengthNumber === ""
  //   ) {
  //     return Promise.reject(new Error("Please enter valid phone."));
  //   }
  //   return Promise.resolve();
  // };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  // const handleSelectChange = (name, value) => {
  //   setState({ ...state, [name]: value });
  // };
  const handleSubmit = async () => {

        const hasBillingPerson = state.delivery_address_billing_keypersons && 
          state.delivery_address_billing_keypersons.some(person => 
            person.persons_name && person.persons_name.trim() !== ""
          );
    
        const hasShippingPerson = state.same_as_billing_address ? true : 
          (state.delivery_address_shipping_keypersons && 
            state.delivery_address_shipping_keypersons.some(person => 
              person.persons_name && person.persons_name.trim() !== ""
            ));
    
        if (!hasBillingPerson) {
          ErrorNotificationMsg(t("Please add at least one person in billing address"));
          setBtnLoading(false);
          return;
        }
    
        if (!hasShippingPerson) {
          ErrorNotificationMsg(t("Please add at least one person in shipping address"));
          setBtnLoading(false);
          return;
        }
    try {
      setBtnLoading(true);
      const payload1 = {
        company: state.company,
        company_legal_name: state.company_legal_name,
        //site_short_name: state.site_short_name,
        site_name: state.site_name,
        gst_number: state.gst_number,
        gst_no_verified: state.gst_no_verified,
        // wbs_choice: "Common Wise For Site",
        //  common_wbs_number: state.common_wbs_number,
        billing_state: state.billing_state,
        billing_city: state.billing_city,
        billing_address_line_1: state.billing_address_line_1,
        billing_address_line_2: state.billing_address_line_2,
        billing_landmark: state.billing_landmark,
        billing_pincode: state.billing_pincode,
        // billing_email: state.billing_email,
        //  billing_phone: state.billing_phone,
        // billing_alternative_phone_number:
        //  state.billing_alternative_phone_number,
        // billing_contact_person_name: state.billing_contact_person_name,
        shipping_state: state.shipping_state,
        shipping_city: state.shipping_city,
        shipping_address_line_1: state.shipping_address_line_1,
        shipping_address_line_2: state.shipping_address_line_2,
        shipping_landmark: state.shipping_landmark,
        shipping_pincode: state.shipping_pincode,
        // shipping_email: state.shipping_email,
        //shipping_phone: state.shipping_phone,
        //   shipping_alternative_phone_number:
        //  state.shipping_alternative_phone_number,
        //  shipping_contact_person_name: state.shipping_contact_person_name,
        same_as_billing_address: state.same_as_billing_address,
        delivery_address_billing_keypersons:
          state.delivery_address_billing_keypersons &&
          state.delivery_address_billing_keypersons.every(
            (person) =>
              person.persons_name === null &&
              person.email === null &&
              person.mobile_number === null
          )
            ? []
            : state.delivery_address_billing_keypersons,

        delivery_address_shipping_keypersons:
          state.delivery_address_shipping_keypersons &&
          state.delivery_address_shipping_keypersons.every(
            (person) =>
              person.persons_name === null &&
              person.email === null &&
              person.mobile_number === null
          )
            ? []
            : state.delivery_address_shipping_keypersons,

        // wbs_numbers:
        //   state.wbs_numbers &&
        //   state.wbs_numbers.every((person) => person.category === null)
        //     ? []
        //     : state.wbs_numbers,
      };
      const payload2 = {
        company: state.company,
        company_legal_name: state.company_legal_name,
        //site_short_name: state.site_short_name,
        site_name: state.site_name,
        gst_number: state.gst_number,
        gst_no_verified: state.gst_no_verified,
        // wbs_choice: "Category Wise WBS",
        // common_wbs_number: null,
        billing_state: state.billing_state,
        billing_city: state.billing_city,
        billing_address_line_1: state.billing_address_line_1,
        billing_address_line_2: state.billing_address_line_2,
        billing_landmark: state.billing_landmark,
        billing_pincode: state.billing_pincode,
        // billing_email: state.billing_email,
        // billing_phone: state.billing_phone,
        //billing_alternative_phone_number:
        //  state.billing_alternative_phone_number,
        //billing_contact_person_name: state.billing_contact_person_name,
        shipping_state: state.shipping_state,
        shipping_city: state.shipping_city,
        shipping_address_line_1: state.shipping_address_line_1,
        shipping_address_line_2: state.shipping_address_line_2,
        shipping_landmark: state.shipping_landmark,
        shipping_pincode: state.shipping_pincode,
        //  shipping_email: state.shipping_email,
        // shipping_phone: state.shipping_phone,
        // shipping_alternative_phone_number:
        // state.shipping_alternative_phone_number,
        //   shipping_contact_person_name: state.shipping_contact_person_name,
        same_as_billing_address: state.same_as_billing_address,
        //   wbs_numbers:
        //  state.wbs_numbers &&
        //    state.wbs_numbers.every((person) => person.category === null)
        //     ? []
        // : state.wbs_numbers,
      };
      const payload =
        selectedOption === "Common Wise For Site" ? payload1 : payload2;
      let apiResponse;
      // const formData = new FormData();
      // formData.append("company_address_master_logo", uploadFileProfilePic);
      // formData.append("form_data", JSON.stringify(payload));
      if (AddressId === null) {
        apiResponse = await postRequest("delivery-address/", payload);
      } else {
        apiResponse = await patchRequest(
          // `delivery-address/${AddressId}/`,
          `delivery-address/${AddressId}/`,
          payload
        );
      }
      if (apiResponse.data.success) {
        handleTabChange("2");
        SuccessNotificationMsg(
          AddressId === null
            ? t("delivery_address_added_successfully")
            : t("delivery_address_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        updateSubscriptionStatus();
        setBtnLoading(false);
        // navigate("/site-location-step");
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  // const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
  // const handleSameAsCurrentAddressChange = (e) => {
  //   const checked = e.target.checked;
  //   setSameAsCurrentAddress(checked);

  //   const billingAddress = formRef.current.getFieldValue("delivery_address[0]");

  //   if (checked) {
  //     setState((prevState) => ({
  //       ...prevState,
  //       // same_as_address: true,
  //       delivery_address: [
  //         billingAddress, // billing address at index 0
  //         {
  //           address_line_1: billingAddress.address_line_1,
  //           landmark: billingAddress.landmark,
  //           city: billingAddress.city,
  //           state: billingAddress.state,
  //           email: billingAddress.email,
  //           phone: billingAddress.phone,
  //           alternative_phone_number: billingAddress.alternative_phone_number,
  //           pincode: billingAddress.pincode,
  //         }, // shipping address at index 1
  //       ],
  //     }));

  //     // Set form values for delivery_address[1]
  //     formRef.current.setFieldsValue({
  //       ship_address_line_1: billingAddress.address_line_1,
  //       ship_landmark: billingAddress.landmark,
  //       ship_city: billingAddress.city,
  //       ship_state: billingAddress.state,
  //       ship_email: billingAddress.email,
  //       ship_phone: billingAddress.phone,
  //       ship_alternative_phone_number: billingAddress.alternative_phone_number,
  //       ship_pincode: billingAddress.pincode,
  //     });
  //   } else {
  //     setState((prevState) => ({
  //       ...prevState,
  //       same_as_address: false,
  //       delivery_address: [
  //         {
  //           address_line_1: "",
  //           landmark: "",
  //           city: "",
  //           state: "",
  //           email: "",
  //           phone4: "",
  //           phone3: "",
  //           pincode_number: "",
  //         }, // billing address at index 0
  //         {
  //           address_line_1: "",
  //           landmark: "",
  //           city: "",
  //           state: "",
  //           email: "",
  //           phone4: "",
  //           phone3: "",
  //           pincode_number: "",
  //         }, // shipping address at index 1
  //       ],
  //     }));

  //     // Set form values for delivery_address[1]
  //     formRef.current.setFieldsValue({
  //       "delivery_address[1].address_line_1": "",
  //       landmark1: "",
  //       city1: "",
  //       state1: "",
  //       email1: "",
  //       phone1: "",
  //       phone_number: "",
  //       pincode_number1: "",
  //     });
  //   }
  // };
  // const addPerson = () => {
  //   let newPersonArr = [
  //     ...state.wbs_numbers,
  //     {
  //       category: 1,
  //       wbs_number: null,
  //     },
  //   ];
  //   setState({ ...state, wbs_numbers: newPersonArr });
  //   setWeightSizeFieldValue(newPersonArr);
  // };

  // const removePerson = async (lastIndex) => {
  //   let filterPersonArr = state.wbs_numbers.filter(
  //     (item, index) => index !== lastIndex
  //   );
  //   setState({ ...state, wbs_numbers: filterPersonArr });
  //   setWeightSizeFieldValue(filterPersonArr);
  // };
  // const handleChangegst = (name, value) => {
  //   setState({ ...state, [name]: value });
  // };

  const gstPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const handleGstInputChange = async (name, value) => {
    // let { name, value } = e.target;
    setVerifyGstButtonView(true);

    setState({ ...state, [name]: value, gst_no_verified: false });
    // Debounce the API call to avoid immediate firing on each keystroke
    setVerificationStatus(null);
    setVerifyDisable(!gstPattern.test(value));

    // debouncedFetchData(value);
  };
  const handleGstNumberVerify = async () => {
    setVerifyDisable(true);
    setVerifyGstButtonView(true);
    try {
      setBtnLoadingVerifyGst(true);
      const gst = state?.gst_number;

      // const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      // if (!gst || !gstRegex.test(gst)) {
      //   ErrorNotificationMsg(t("Invalid GST No."));
      //   setVerificationResultGST('error');
      //   return;
      // }

      // setBtnLoading(true);
      const response = await getRequest(`doc-verification/gst/?gst_no=${gst}`);
      // console.log(response, "responseddd");
      if (response.data.results.data) {
        SuccessNotificationMsg("GST verified successfully");
        setVerificationStatus("success");
        setBtnLoadingVerifyGst(false);
        setVerifyGstButtonView(false);
        setVerifyDisable(false);
      } else {
        // Handle case when GST number is not valid
        ErrorNotificationMsg(t("Invalid GST No."));
        // setVerificationStatus("failure");
        setBtnLoadingVerifyGst(false);
        setVerifyGstButtonView(true);
        setVerifyDisable(false);
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying GST number"));
      // setVerificationStatus("failure");
      setBtnLoadingVerifyGst(false);
      setVerifyGstButtonView(true);
      setVerifyDisable(false);
    }
  };
  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["persons_name" + objectKey] = objectValue.persons_name;
      fieldObject["email" + objectKey] = objectValue.email;
      // fieldObject["designation" + objectKey] = objectValue.designation;
      // fieldObject["department" + objectKey] = objectValue.department;
      fieldObject["mobile_number" + objectKey] = String(
        objectValue.mobile_number
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  // const handleCloneInputChange = (field, e, index) => {
  //   let newPersonArr = state.wbs_numbers;
  //   newPersonArr[index][field] = e.target.value ? e.target.value : null;
  //   setState({ ...state, wbs_numbers: newPersonArr });
  // };

  // const handleCloneSelectChange = (field, value, index) => {
  //   let newFeatureArr = state.wbs_numbers;
  //   if (newFeatureArr[index]) {
  //     newFeatureArr[index][field] = value;
  //     setState({ ...state, wbs_numbers: newFeatureArr });
  //   }
  // };

  const handleSameAsCurrentAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsCurrentAddress(checked);
    const defaultCountryCode = "+91";
    if (checked) {
      setState((prevState) => {
        return {
          ...prevState,
          same_as_billing_address: true,
          shipping_state: prevState.billing_state,
          shipping_city: prevState.billing_city,
          shipping_address_line_1: prevState.billing_address_line_1,
          shipping_address_line_2: prevState.billing_address_line_2,
          shipping_landmark: prevState.billing_landmark,
          shipping_pincode: prevState.billing_pincode,
          shipping_pincode_number: prevState.billing_pincode_number,
          shipping_email: prevState.billing_email,
          shipping_phone: prevState.billing_phone,
          shipping_alternative_phone_number:
            prevState.billing_alternative_phone_number,
          shipping_contact_person_name: prevState.billing_contact_person_name,
        };
      });
      formRef.current.setFieldsValue({
        shipping_state: state.billing_state,
        shipping_city: state.billing_city,
        shipping_address_line_1: state.billing_address_line_1,
        shipping_address_line_2: state.billing_address_line_2,
        shipping_landmark: state.billing_landmark,
        shipping_pincode: state.billing_pincode_number,
        // shipping_pincode: state.billing_pincode,
        shipping_email: state.billing_email,
        shipping_phone: state.billing_phone
          ? state.billing_phone
          : defaultCountryCode,
        shipping_alternative_phone_number:
          state.billing_alternative_phone_number
            ? state.billing_alternative_phone_number
            : defaultCountryCode,
        shipping_contact_person_name: state.billing_contact_person_name,
      });

      if (
        state?.billing_state !== null &&
        state?.billing_state !== undefined &&
        state?.billing_state !== ""
      ) {
        // console.log(state?.billing_state, "Inside");
        //getCityByStateForShipping(state.billing_state); //1 0
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        same_as_billing_address: false,
        shipping_state: "",
        shipping_city: "",
        shipping_address_line_1: "",
        shipping_address_line_2: "",
        shipping_landmark: "",
        shipping_pincode_number: "",
        shipping_email: "",
        shipping_phone: "",
        shipping_alternative_phone_number: "",
        shipping_contact_person_name: "",
      }));

      formRef.current.setFieldsValue({
        shipping_state: "",
        shipping_city: "",
        shipping_address_line_1: "",
        shipping_address_line_2: "",
        shipping_landmark: "",
        shipping_pincode_number: "",
        shipping_pincode: null,
        shipping_email: "",
        shipping_phone: defaultCountryCode,
        shipping_alternative_phone_number: defaultCountryCode,
        shipping_contact_person_name: "",
      });
    }
  };

  // const colors = ["#094E8F"];
  return (
    <>
      {/* <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View and manage site locations relevant to your procurement
                  activities.
                </span>
              }
            >
              <h3>{t("pl_site_location")}</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/delivery-address">{t("pl_site_location_list")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_site_location")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div> */}
      <Layout>
        <StepSider />
        <Content className="corecontent">
           <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
          
            <h3>Site Location</h3>

          
            </div>
          
          
        </div>
      </div>
      <section className="grid-sec FormSection Container">
        <div className="FormBody" style={{padding:'0'}}>
          <div className="stepscontentwrap">
            {/* <div className="pagetitle">
              <span>Add Site Location</span>
            </div> */}
            <Tabs
              activeKey={activeKey}
              // onChange={handleTabChange}
              className="custom-tabs"
            >
              <TabPane tab="01 Site Basic Detail" key="1">
                <Spin spinning={apiLoading}>
                  <Form
                    onFinish={handleSubmit}
                    autoComplete="off"
                    ref={formRef} className="tabscrolldivwrap"
                  >
                    <div className="tabscrolldiv">
                    <div className="stepsContent">
                      <div className="formwrapper">
                        <div className="formrowsection">
                          <Row gutter={16}>
                            <Col xs={24} sm={24} md={12} xl={8}>
                              <div className="verifywrap">
                                <Form.Item
                                  label="GST Number"
                                  name="gst_number"
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>{t("val_gst_number")}</Trans>
                                      ),
                                    },
                                    {
                                      pattern:
                                        /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/,
                                      message: "Enter a valid GST number",
                                    },
                                  ]}
                                  // initialValue={state.gst_rate}
                                >
                                  <Input
                                    //type="number"
                                    placeholder={t("pl_enter_gst_number")}
                                    value={state?.gst_number}
                                    onKeyPress={(e) => {
                                      if (e.key === "." || e.key === "e") {
                                        e.preventDefault(); // Prevent entering a dot
                                      }
                                    }}
                                    onChange={(e) =>
                                      handleGstInputChange(
                                        "gst_number",
                                        e.target.value
                                      )
                                    }
                                    // value={state.gst_rate}
                                    // onChange={(e) =>
                                    //   handleGstRateChange(
                                    //     parseInt(e.target.value, 10) || null
                                    //   )
                                    // }
                                    prefix={<AddressLine />}
                                  />
                                </Form.Item>

                                {verifyGstButtonView === true ? (
                                  <ButtonField
                                    type="primary"
                                    label={t("Verify")}
                                    className="SaveGradiantBtn verify"
                                    loading={btnLoadingVerifyGst}
                                    onClick={handleGstNumberVerify}
                                    disabled={
                                      state?.gst_number
                                        ? verifyGstDisable
                                        : true
                                    }
                                  />
                                ) : (
                                  ""
                                )}

                                {/* {verificationStatus === "success" && (
                                  // <img
                                  //   src={verifybtn}
                                  //   style={{
                                  //     height: "36px",
                                  //     marginTop: "29px",
                                  //   }}
                                  // ></img>
                                  // <verifyGST className="large-icon" style={{ color: 'green' }} />
                                )} */}
                              </div>
                            </Col>
                            <Col xs={24} sm={24} md={12} xl={8}>
                              <InputField
                                name="company_legal_name"
                                label="Legal Name Of Business"
                                pattern={"^[a-zA-Z ]+$"}
                                //initialValue={state.company_legal_name}
                                placeholder={t("Enter legal name of business")}
                                rules={t("val_select_company_name")}
                                prefix={<AddressLine />}
                                handleInputChange={handleInputChange}
                              />
                            </Col>
                            <Col xs={24} sm={24} md={12} xl={8}>
                              <InputField
                                name="site_name"
                                label={t("label_site_short_name")}
                                //initialValue={state.company_legal_name}
                                placeholder={t("pl_site_short_name")}
                                rules={t("val_site_short_name")}
                                prefix={<AddressLine />}
                                handleInputChange={handleInputChange}
                                pattern={"^[a-zA-Z ]+$"}
                              />
                            </Col>
                          </Row>
                        </div>
                        <Row gutter={32}>
                          <Col xs={12} xxl={12} className="bdr">
                            <div className="colwrap">
                              <div className="colsubtitle">Billing Address</div>
                              <Row gutter={16}>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="billing_address_line_1"
                                    label={t("Shop No, Building")}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_please_enter_address")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder={t("pl_enter_shop_no")}
                                      value={state.billing_address_line_1}
                                      onChange={(e) =>
                                        handleChange(
                                          "billing_address_line_1",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="billing_address_line_2"
                                    label={t("Area, Street")}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_please_enter_address")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder={t("pl_enter_area_street")}
                                      value={state.billing_address_line_2}
                                      onChange={(e) =>
                                        handleChange(
                                          "billing_address_line_2",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="billing_landmark"
                                    label={t("pl_landmark")}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_please_enter_land_mark")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder={t("place_land_mark")}
                                      value={state.billing_landmark}
                                      onChange={(e) =>
                                        handleChange(
                                          "billing_landmark",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="billing_pincode"
                                    label={t("pl_pincode")}
                                    prefix={<ZipCode />}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_postal_zip_code")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <AutoComplete
                                      className="autoComplete"
                                      //onSelect={onSelectBilling}
                                      onSearch={onSearchBilling}
                                      value={state.billing_pincode}
                                      optionFilterProp="children"
                                      allowClear
                                      placeholder={t("pl_pincodeselect")}
                                      onChange={handlePincodeBillingChange}
                                    >
                                      {pincodeListBilling.map((option) => (
                                        <Option
                                          key={option.id}
                                          value={option.pincode_number}
                                        >
                                          {option.pincode_number}
                                        </Option>
                                      ))}
                                    </AutoComplete>
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="billing_city"
                                    label={t("pl_city")}
                                    // value={state.role}

                                    // prefix={<User />}
                                    rules={[
                                      {
                                        required: true,
                                        message: <Trans>{t("val_city")}</Trans>,
                                      },
                                    ]}
                                  >
                                    {/* <Select
                      showArrow
                      showSearch
                      optionFilterProp="children"
                      placeholder={t("place_city")}
                      // onChange={(value) => handleRoleSelectChange(value)}
                      // onChange={(value) =>
                      //   handleChange("billing_city", value)
                      // }
                      onChange={handleCityChange}
                      prefix={<ZipCode />}
                    >
                      {/* {cityDropdownOptions.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))} * /}
                      {cityDropdownOptions.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select> */}
                                    <Input
                                      placeholder={t("place_city")}
                                      // value={state.billing_city}
                                      value={state.billing_city}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="billing_state"
                                    label={t("pl_state")}
                                    // value={state.role}
                                    // prefix={<User />}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_state_province")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    {/* <Select
                      showArrow
                      showSearch
                      placeholder={t("place_state")}
                      optionFilterProp="children"
                      // onChange={(value) => handleRoleSelectChange(value)}
                      // onChange={(value) =>
                      //   handleChange("billing_state", value)
                      // }
                      // onChange={handleStateChange}
                      value={state.billing_state}
                      prefix={<ZipCode />}
                    >
                      {stateDropdownOptions.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select> */}
                                    <Input
                                      value={state.billing_state}
                                      placeholder={t("place_state")}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col>

                                <BillingSiteLocationKeyPerson
                                  state={state}
                                  setState={setState}
                                  companyId={CompanyId}
                                />
                                {/* <Col
                          xs={24}
                          xl={24}
                        >
                          <Row gutter={16}>

                            <Col
                              xs={24}
                              sm={12}
                              xl={7}
                            >
                              <Form.Item

                              ><label>*Person Name </label>
                                <Input
                                  type="text"
                                  placeholder="Enter Person Name"
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              xs={24}
                              sm={12}
                              xl={7}
                            >
                              <Form.Item

                              ><label>*Email </label>
                                <Input
                                  type="text"
                                  placeholder="Enter Email"
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              xs={24}
                              sm={12}
                              xl={7}
                            >
                              <Form.Item

                              ><label>*Mobile Number </label>
                                <div className="phonefield">
                                  <PhoneInput
                                    country={"in"}
                                    className="PhoneSection"

                                  />
                                </div>
                              </Form.Item>
                            </Col>
                            <Col
                              xs={12}
                              xl={3}
                            >
                              <div className="addwrp">
                                <Space>



                                  <MinusSquareFilled
                                    className="add"
                                  />
                                </Space>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          xs={24}
                          xl={24}
                        >
                          <Row gutter={16}>

                            <Col
                              xs={24}
                              sm={12}
                              xl={7}
                            >
                              <Form.Item

                              ><label>*Person Name </label>
                                <Input
                                  type="text"
                                  placeholder="Enter Person Name"
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              xs={24}
                              sm={12}
                              xl={7}
                            >
                              <Form.Item

                              ><label>*Email </label>
                                <Input
                                  type="text"
                                  placeholder="Enter Email"
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              xs={24}
                              sm={12}
                              xl={7}
                            >
                              <Form.Item

                              ><label>*Mobile Number </label>
                                <div className="phonefield">
                                  <PhoneInput
                                    country={"in"}
                                    className="PhoneSection"

                                  />
                                </div>
                              </Form.Item>
                            </Col>
                            <Col
                              xs={12}
                              xl={3}
                            >
                              <div className="addwrp">
                                <Space>



                                  <MinusSquareFilled
                                    className="add"
                                  />
                                </Space>
                              </div>
                            </Col>
                          </Row>
                        </Col> */}
                              </Row>
                            </div>
                          </Col>
                          <Col xs={12} xxl={12}>
                            <div className="colwrap">
                              <div className="colsubtitle">
                                Shipping Address
                                {/* <Checkbox>
                    Same as my Billing Address
                  </Checkbox> */}
                                <Tooltip
                                  title="Same as Billing Address"
                                  name="same_as_billing_address"
                                >
                                  <Checkbox
                                    style={{ marginLeft: "10px" }}
                                    checked={sameAsCurrentAddress}
                                    onChange={(e) =>
                                      handleSameAsCurrentAddressChange(e)
                                    }
                                  >
                                    Same as my Billing Address
                                  </Checkbox>
                                </Tooltip>
                              </div>
                              <Row gutter={16}>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="shipping_address_line_1"
                                    label={t("Shop No, Building")}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_please_enter_address")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder={t("pl_enter_shop_no")}
                                      value={state.shipping_address_line_1}
                                      onChange={(e) =>
                                        handleChange(
                                          "shipping_address_line_1",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="shipping_address_line_2"
                                    label={t("Area, Street")}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_please_enter_address")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder={t("pl_enter_area_street")}
                                      value={state.shipping_address_line_2}
                                      onChange={(e) =>
                                        handleChange(
                                          "shipping_address_line_2",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="shipping_landmark"
                                    label={t("pl_landmark")}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_please_enter_land_mark")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder={t("place_land_mark")}
                                      value={state.shipping_landmark}
                                      onChange={(e) =>
                                        handleChange(
                                          "shipping_landmark",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="shipping_pincode"
                                    label={t("pl_pincode")}
                                    prefix={<ZipCode />}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_postal_zip_code")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <AutoComplete
                                      className="autoComplete"
                                      // onSelect={onSelectShipping}
                                      onSearch={onSearchShipping}
                                      value={state.shipping_pincode}
                                      optionFilterProp="children"
                                      allowClear
                                      placeholder={t("pl_pincodeselect")}
                                      onChange={handlePincodeShippingChange}
                                      // onChange={(value) =>
                                      //   handlePincodeShippingChange(
                                      //     "shipping_pincode",
                                      //     value
                                      //   )
                                      // }
                                    >
                                      {pincodeListShipping.map((option) => (
                                        <Option
                                          key={option.id}
                                          value={option.pincode_number}
                                        >
                                          {option.pincode_number}
                                        </Option>
                                      ))}
                                    </AutoComplete>
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="shipping_city"
                                    label={t("pl_city")}
                                    // value={state.role}
                                    // value={state.shipping_city}
                                    // prefix={<User />}
                                    rules={[
                                      {
                                        required: true,
                                        message: <Trans>{t("val_city")}</Trans>,
                                      },
                                    ]}
                                  >
                                    {/* <Select
                            showArrow
                            showSearch
                           
                            // onChange={(value) => handleRoleSelectChange(value)}
                            // onChange={(value) =>
                            //   handleChange("shipping_city", value)
                            // }
                            onChange={handleCityChangeShipping}
                            prefix={<ZipCode />}
                          >
                            {cityDropdownOptionsShipping.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select> */}
                                    <Input
                                      placeholder={t("place_city")}
                                      value={state.shipping_city}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    name="shipping_state"
                                    label={t("pl_state")}
                                    // value={state.role}
                                    // value={state.shipping_state}
                                    // prefix={<User />}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("val_state_province")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    {/* <Select
                            showArrow
                            showSearch
                            placeholder={t("place_state")}
                            // onChange={(value) =>
                            //   handleChange("shipping_state", value)
                            // }
                            onChange={handleStateChangeShipping}
                            prefix={<ZipCode />}
                          >
                            {stateDropdownOptionsShipping.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.name}
                              </Option>
                            ))} */}
                                    <Input
                                      placeholder={t("place_state")}
                                      value={state.shipping_state}
                                      disabled
                                    />
                                    {/* </Select> */}
                                  </Form.Item>
                                </Col>

                                <ShippingSiteLocationKeyPerson
                                  state={state}
                                  setState={setState}
                                  companyId={CompanyId}
                                />
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
</div>
                    <div className="stepsFooter">
                      <Button
                        cursor="pointer"
                        type="secondary"
                        className="primary"
                        onClick={() => navigate("/site-location-step")}
                      >
                        Cancel
                      </Button>
                      <Button
                        cursor="pointer"
                        type="primary"
                        className="primary"
                        htmlType="Submit"
                        label={t("save")}
                        loading={btnLoading}
                      >
                        Save & Next
                      </Button>
                    </div>
                  </Form>
                </Spin>
              </TabPane>
              {/* <TabPane tab="02 Selection Of Material" key="2"> */}
              <TabPane
                tab={
                  <span>
                    02 Selection Of Material{" "}
                    <Tooltip
                      color="#094E8F"
                      placement="top"
                      title={
                        <span style={{ color: "#fff" }}>
                          Please select or deselect the materials to be used at
                          this specific site location. Note that only the
                          materials selected here will be available for the PR
                          to PO process for this site.
                        </span>
                      }
                    >
                      <InfoCircleOutlined
                        style={{ color: "white", marginLeft: "3px" }}
                      />
                    </Tooltip>
                  </span>
                }
                key="2"
              >
                <SiteWiseMaterialCompany setActiveKey={handleTabChange} />
              </TabPane>
            </Tabs>
          </div>
          </div></section>
        </Content>
      </Layout>
    </>
  );
};

export default AddSiteLocationStep;
